<template>
  <div
    v-if="$vuetify.breakpoint.smAndUp"
    class="d-flex align-center top-bar-external"
  >
    <a
      v-for="link of links"
      :key="link.label"
      class="app-bar-icon-btn top-bar-external__link"
      :href="link.link"
      target="_blank"
      rel="noopener noreferrer"
      :aria-label="linkLabel(link.label)"
      :title="linkLabel(link.label)"
      :data-test="'top-bar-' + link.icon"
    >
      <v-icon aria-hidden="true">{{ link.icon }}</v-icon>
    </a>
  </div>
</template>

<script lang="ts">
    import Vue from "vue";
    import {ExternalLinks} from "@/config/ExternalLinks";

    interface link {
        link: string,
        label: string,
        icon: string
    }

    export default Vue.extend({
        name: "TopBarLinks",
        data: () => ({
            links: [{
                link: 'https://calendly.com/seowritee',
                label: 'topBar.promo',
                icon: 'video_call'
            }, {
                link: ExternalLinks.manual,
                label: 'topBar.manual',
                icon: 'help_outline'
            }, {
                link: ExternalLinks.blog,
                label: 'topBar.blog',
                icon: 'menu_book'
            }] as link[]
        }),
        methods: {
            linkLabel: function (key: string): string {
                return String(this.$t(key));
            },
        },
    });
</script>

<style scoped>
.top-bar-external {
  display: flex;
  align-items: center;
  gap: 8px;
}

.top-bar-external__link {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  color: inherit;
  text-decoration: none;
  border-radius: 50%;
}

.top-bar-external__link:focus {
  outline: 2px solid currentColor;
  outline-offset: 2px;
}
</style>
